import AppRoot from './app-root.component';

export const AppRootContainer = AppRoot;